import { render, staticRenderFns } from "./WaitingPrice.vue?vue&type=template&id=23ca5d07"
import script from "./WaitingPrice.vue?vue&type=script&lang=js"
export * from "./WaitingPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports